<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm1">
<p class="para" style="text-indent: 0%; text-align:center; margin-top:2em;"><em class="italic"><span class="chapterOpenerFirstLetters">T</span>hig crioch air an t-saoghal, ach mairidh gaol is ceòl.</em></p>
<p class="para" style="text-indent: 0%; text-align:center;">The world will end but love and music endure.</p>
<p class="para" style="text-indent: 0%; text-align:center; margin-top:2em;"><img alt="images" src="images/open.jpg" style="vertical-align:middle;"/> SCOTTISH GAELIC PROVERB <img alt="images" src="images/close.jpg" style="vertical-align:middle;"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545539364_fm001.vue?45c83726